const values = {
  COMMON: 'Từ vựng thông dụng',
  LEARNING: 'Cách học từ vựng',
  TOPIC: 'Từ vựng theo chủ đề',
  READING: 'Từ vựng reading',
  LISTENING: 'Từ vựng listening',
  WRITING: 'Từ vựng writing',
  SPEAKING: 'Từ vựng speaking',
};

export const VocabType = {
  NOUN: 'NOUN',
  VERB: 'VERB',
  ADV: 'ADV',
  ADJ: 'ADJ',
  PREPOSITION: 'PREPOSITION',
  CONJUNCTION: 'CONJUNCTION',
  ARTICLE: 'ARTICLE',
  INTERJECTION: 'INTERJECTION',
  PRONOUN: 'PRONOUN',
  PHRASE: 'PHRASE',
} as const;

export type VocabType = (typeof VocabType)[keyof typeof VocabType];

export const getVocabTypeEnumTextByKey = (key) => {
  return values[key];
};
